/*compilation-strategies*/
/*just-in-time-packages*/
/*limitations-and-tradeoffs*/
/*compiled-packages*/
/*limitations-and-tradeoffs-1*/
/*publishable-packages*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "内部软件包",
  "description": "了解如何在 monorepo 中构建内部包。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "内部包是源代码位于你的工作区内的库。你可以快速创建内部包，以便在你的 monorepo 中共享代码，并在以后需要时选择 将它们发布到 npm 注册表。"
  }, {
    "heading": "",
    "content": "¥Internal Packages are libraries whose source code is inside your Workspace. You can quickly make Internal Packages to share code within your monorepo and choose to publish them to the npm registry if you need to later."
  }, {
    "heading": "",
    "content": "内部包通过将它们安装在 package.json 中在你的存储库中使用，类似于来自 npm 注册表的外部包。但是，你可以使用包管理器的工作区安装语法引用包，而不是标记要安装的版本："
  }, {
    "heading": "",
    "content": "¥Internal Packages are used in your repository by installing them in package.json similar to an external package coming from the npm registry. However, instead of marking a version to install, you can reference the package using your package manager's workspace installation syntax:"
  }, {
    "heading": "",
    "content": "在 创建内部包指南 中，你可以使用 编译包策略 从头构建内部包。在本页面中，我们将介绍创建内部包的其他策略及其利弊，包括使用 将软件包发布到 npm 注册表 创建外部包。"
  }, {
    "heading": "",
    "content": "¥In the Creating an Internal Package guide, you can build an Internal Package from the beginning using the Compiled Package strategy. On this page, we'll describe other strategies for creating Internal Packages and their tradeoffs, including publishing the package to the npm registry to create an External Package."
  }, {
    "heading": "",
    "content": "然后，你可以像使用外部包一样将包导入到你的代码中："
  }, {
    "heading": "",
    "content": "¥You can then import the package into your code like you're used to doing with an external package:"
  }, {
    "heading": "编译策略-compilation-strategies",
    "content": "¥Compilation Strategies"
  }, {
    "heading": "编译策略-compilation-strategies",
    "content": "根据你的库需求，你可以选择以下三种编译策略之一："
  }, {
    "heading": "编译策略-compilation-strategies",
    "content": "¥Depending on what you need from your library, you can choose one of three compilation strategies:"
  }, {
    "heading": "编译策略-compilation-strategies",
    "content": "即时软件包：通过允许应用打包器在使用包时对其进行编译，为你的包创建最小配置。"
  }, {
    "heading": "编译策略-compilation-strategies",
    "content": "¥Just-in-Time Packages: Create minimal configuration for your package by allowing application bundlers to compile the package as it uses it."
  }, {
    "heading": "编译策略-compilation-strategies",
    "content": "已编译的软件包：使用适量的配置，使用构建工具（例如 tsc）或打包器编译你的软件包。"
  }, {
    "heading": "编译策略-compilation-strategies",
    "content": "¥Compiled Packages: With a moderate amount of configuration, compile your package using a build tool like tsc or a bundler."
  }, {
    "heading": "编译策略-compilation-strategies",
    "content": "可发布的软件包：编译并准备一个包以发布到 npm 仓库。此方法需要最多的配置。"
  }, {
    "heading": "编译策略-compilation-strategies",
    "content": "¥Publishable Packages: Compile and prepare a package to publish to the npm registry. This approach requires the most configuration."
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥Just-in-Time Packages"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "即时包由使用它的应用编译。这意味着你可以直接使用你的 TypeScript（或未编译的 JavaScript）文件，所需的配置比本页上的其他策略少得多。"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥A Just-in-Time package is compiled by the application that uses it. This means you can use your TypeScript (or uncompiled JavaScript) files directly, requiring much less configuration than the other strategies on this page."
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "此策略在以下情况下最有用："
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥This strategy is most useful when:"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "你的应用是使用 Turbopack、webpack 或 Vite 等现代打包工具构建的。"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥Your applications are built using a modern bundler like Turbopack, webpack, or Vite."
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "你希望避免配置和设置步骤。"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥You want to avoid configuration and setup steps."
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "即使软件包无法命中缓存，你对应用的构建时间也感到满意。"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥You're satisfied with your applications' build times, even when you can't hit cache for the package."
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "即时包的 package.json 可能如下所示："
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥A package.json for a Just-in-Time package may look like this one:"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "在 package.json 中，有几点需要注意："
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥There are a few important things to notice in this package.json:"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "直接导出 TypeScript：exports 字段标记包的入口点，在本例中，你直接引用的是 TypeScript 文件。这是因为应用的打包器会在构建过程中使用代码时对其进行编译。"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥Directly exporting TypeScript: The exports field marks the entrypoints for the package and, in this case, you're referencing TypeScript files directly. This is possible because the bundler for the application will compile the code as it uses it in its build process."
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "不支持 build 脚本：由于此包导出的是 TypeScript，因此无需构建步骤来转译包。这意味着你无需在此包中配置构建工具即可使其在你的工作区中工作。"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥No build script: Because this package is exporting TypeScript, it doesn't need a build step for transpiling the package. This means you don't have to configure a build tool in this package to make it work in your Workspace."
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs",
    "content": "¥Limitations and tradeoffs"
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs",
    "content": "仅在使用者进行转译时适用：此策略仅当包将用于使用打包器或原生支持 TypeScript 的工具时才适用。消费者的打包器负责将 TypeScript 包转换为 JavaScript。如果你的构建或包的其他用法无法使用 TypeScript，则需要迁移到 已编译的软件包 策略。"
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs",
    "content": "¥Only applicable when consumers do transpiling: This strategy can only be used when the package is going to be used in tooling that uses a bundler or natively understands TypeScript. The consumer's bundler is responsible for transpiling the TypeScript packages to JavaScript. If your builds or other usages of the package are not able to consume TypeScript, you will need to move to the Compiled Packages strategy."
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs",
    "content": "不支持 TypeScript paths：正在被使用者转译的库无法使用 compilerOptions.paths 配置，因为 TypeScript 假定源代码是在编写它的包中进行转译的。如果你使用的是 TypeScript 5.4 或更高版本，我们推荐使用 使用 Node.js 子路径导入。要了解如何操作，请访问 我们的 TypeScript 页面。"
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs",
    "content": "¥No TypeScript paths: A library that is being transpiled by its consumer cannot use the compilerOptions.paths configuration because TypeScript assumes that source code is being transpiled in the package where it is written. If you're using TypeScript 5.4 or later, we recommend using Node.js subpath imports. To learn how, visit our TypeScript page."
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs",
    "content": "Turborepo 无法缓存即时软件包的构建：由于该包没有自己的 build 步骤，因此无法被 Turborepo 缓存。如果你希望将配置保持在最低限度，并且对应用的构建时间没有异议，那么这种权衡可能对你来说很有意义。"
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs",
    "content": "¥Turborepo cannot cache a build for a Just-in-Time Package: Because the package doesn't have its own build step, it can't be cached by Turborepo. This tradeoff may make sense for you if you want to keep configuration to a minimum and are okay with the build times for your applications."
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs",
    "content": "将报告内部依赖中的错误：直接导出 TypeScript 时，如果内部依赖中的代码存在 TypeScript 错误，则依赖包中的类型检查将失败。在某些情况下，你可能会发现这令人困惑或有问题。"
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs",
    "content": "¥Errors in internal dependencies will be reported: When directly exporting TypeScript, type-checking in a dependent package will fail if code in an internal dependency has TypeScript errors. You may find this confusing or problematic in some situations."
  }, {
    "heading": "已编译的软件包-compiled-packages",
    "content": "¥Compiled Packages"
  }, {
    "heading": "已编译的软件包-compiled-packages",
    "content": "已编译包是指使用构建工具（例如 tsc（TypeScript 编译器））自行编译的包。"
  }, {
    "heading": "已编译的软件包-compiled-packages",
    "content": "¥A Compiled Package is a package that handles its own compilation using a build tool, like tsc (the TypeScript compiler)."
  }, {
    "heading": "已编译的软件包-compiled-packages",
    "content": "编译库会将编译后的 JavaScript 输出生成到目录（dist、build 等），你将使用该目录作为包的入口点。构建输出一旦添加到 任务的 outputs 键 中，就会被 Turborepo 缓存，从而加快构建速度。"
  }, {
    "heading": "已编译的软件包-compiled-packages",
    "content": "¥Compiling your library produces compiled JavaScript outputs into a directory (dist, build, etc.) that you will use for the entrypoints for your package. The build outputs will be cached by Turborepo once they're added to the outputs key of the task, allowing you to have faster build times."
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs-1",
    "content": "¥Limitations and tradeoffs"
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs-1",
    "content": "使用 TypeScript 编译器：大多数已编译的包都应该使用 tsc。由于该软件包很可能被使用打包器的应用使用，因此应用的打包器将准备库软件包，以便在应用的最终软件包中分发，处理 polyfill、降级和其他问题。仅当你有特定用例需要它时才应使用打包器，例如将静态资源打包到包的输出中。"
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs-1",
    "content": "¥Using the TypeScript compiler: The majority of Compiled Packages should use tsc. Since the package is highly likely to be consumed by an application that is using a bundler, the application's bundler will prepare the library package for distribution in the application's final bundles, handling polyfilling, downleveling, and other concerns. A bundler should only be used if you have a specific use case that requires it, like bundling static assets into your package's outputs."
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs-1",
    "content": "更多配置：编译包需要更深入的知识和配置才能创建构建输出。有些 TypeScript 编译器的许多配置 可能难以管理和理解，并且需要进一步配置以针对打包器（例如 package.json 中的 sideEffects 键）进行优化。你可以在 我们的专用 TypeScript 指南 中找到我们的一些建议。"
  }, {
    "heading": "限制和权衡-limitations-and-tradeoffs-1",
    "content": "¥More configuration: Compiled Packages require deeper knowledge and configuration to create build outputs. There are many configurations for the TypeScript compiler that can be difficult to manage and understand, and further configuration to optimize for bundlers, like the sideEffects key in package.json. You can find some of our recommendations in our dedicated TypeScript guide."
  }, {
    "heading": "可发布的包-publishable-packages",
    "content": "¥Publishable packages"
  }, {
    "heading": "可发布的包-publishable-packages",
    "content": "将包发布到 npm 仓库符合本页面打包策略中最严格的要求。由于你不了解从注册表下载包的用户将如何使用你的包，因此你可能会发现这很困难，因为要构建一个健壮的包需要进行大量配置。"
  }, {
    "heading": "可发布的包-publishable-packages",
    "content": "¥Publishing a package to the npm registry comes with the most strict requirements of the packaging strategies on this page. Because you don't know anything about how your package will be used by consumers who download the package from the registry, you may find it difficult due to the numerous configurations required for a robust package."
  }, {
    "heading": "可发布的包-publishable-packages",
    "content": "此外，将包发布到 npm 注册表的过程需要专业知识和工具。我们推荐使用 changesets 来管理版本控制、变更日志和发布流程。"
  }, {
    "heading": "可发布的包-publishable-packages",
    "content": "¥Additionally, the process of publishing a package to the npm registry requires specialized knowledge and tooling. We recommend changesets for managing versioning, changelogs, and the publishing process."
  }, {
    "heading": "可发布的包-publishable-packages",
    "content": "详细指南：请访问 我们的软件包发布指南。"
  }, {
    "heading": "可发布的包-publishable-packages",
    "content": "¥For a detailed guide, visit our Publishing packages guide."
  }],
  "headings": [{
    "id": "编译策略-compilation-strategies",
    "content": "编译策略 /*compilation-strategies*/"
  }, {
    "id": "即时软件包-just-in-time-packages",
    "content": "即时软件包 /*just-in-time-packages*/"
  }, {
    "id": "限制和权衡-limitations-and-tradeoffs",
    "content": "限制和权衡 /*limitations-and-tradeoffs*/"
  }, {
    "id": "已编译的软件包-compiled-packages",
    "content": "已编译的软件包 /*compiled-packages*/"
  }, {
    "id": "限制和权衡-limitations-and-tradeoffs-1",
    "content": "限制和权衡 /*limitations-and-tradeoffs-1*/"
  }, {
    "id": "可发布的包-publishable-packages",
    "content": "可发布的包 /*publishable-packages*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
export const toc = [{
  depth: 2,
  url: "#编译策略-compilation-strategies",
  title: _jsx(_Fragment, {
    children: "编译策略 "
  })
}, {
  depth: 3,
  url: "#即时软件包-just-in-time-packages",
  title: _jsx(_Fragment, {
    children: "即时软件包 "
  })
}, {
  depth: 4,
  url: "#限制和权衡-limitations-and-tradeoffs",
  title: _jsx(_Fragment, {
    children: "限制和权衡 "
  })
}, {
  depth: 3,
  url: "#已编译的软件包-compiled-packages",
  title: _jsx(_Fragment, {
    children: "已编译的软件包 "
  })
}, {
  depth: 4,
  url: "#限制和权衡-limitations-and-tradeoffs-1",
  title: _jsx(_Fragment, {
    children: "限制和权衡 "
  })
}, {
  depth: 3,
  url: "#可发布的包-publishable-packages",
  title: _jsx(_Fragment, {
    children: "可发布的包 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["内部包是源代码位于你的工作区内的库。你可以快速创建内部包，以便在你的 monorepo 中共享代码，并在以后需要时选择 ", _jsx(_components.a, {
        href: "/docs/guides/publishing-libraries",
        children: "将它们发布到 npm 注册表"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Internal Packages are libraries whose source code is inside your Workspace. You can quickly make Internal Packages to share code within your monorepo and choose to ", _jsx(_components.a, {
        href: "/docs/guides/publishing-libraries",
        children: "publish them to the npm registry"
      }), " if you need to later."]
    }), "\n", _jsxs(_components.p, {
      children: ["内部包通过将它们安装在 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中在你的存储库中使用，类似于来自 npm 注册表的外部包。但是，你可以使用包管理器的工作区安装语法引用包，而不是标记要安装的版本："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Internal Packages are used in your repository by installing them in ", _jsx(_components.code, {
        children: "package.json"
      }), " similar to an external package coming from the npm registry. However, instead of marking a version to install, you can reference the package using your package manager's workspace installation syntax:"]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "创建内部包指南"
      }), " 中，你可以使用 ", _jsx(_components.a, {
        href: "#compiled-packages",
        children: "编译包策略"
      }), " 从头构建内部包。在本页面中，我们将介绍创建内部包的其他策略及其利弊，包括使用 ", _jsx(_components.a, {
        href: "#publishable-packages",
        children: "将软件包发布到 npm 注册表"
      }), " 创建外部包。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In the ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "Creating an Internal Package guide"
      }), ", you can build an Internal Package from the beginning using ", _jsx(_components.a, {
        href: "#compiled-packages",
        children: "the Compiled Package strategy"
      }), ". On this page, we'll describe other strategies for creating Internal Packages and their tradeoffs, including ", _jsx(_components.a, {
        href: "#publishable-packages",
        children: "publishing the package to the npm registry"
      }), " to create an External Package."]
    }), "\n", _jsx(_components.p, {
      children: "然后，你可以像使用外部包一样将包导入到你的代码中："
    }), "\n", _jsx(_components.p, {
      children: "¥You can then import the package into your code like you're used to doing with an external package:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/app/page.tsx",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { Button } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '@repo/ui'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "; "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "export"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " default"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " function"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " Page"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "() {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  return"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " <"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "Button"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ">Submit</"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "Button"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ">;"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "编译策略-compilation-strategies",
      children: "编译策略 "
    }), "\n", _jsx(_components.p, {
      children: "¥Compilation Strategies"
    }), "\n", _jsx(_components.p, {
      children: "根据你的库需求，你可以选择以下三种编译策略之一："
    }), "\n", _jsx(_components.p, {
      children: "¥Depending on what you need from your library, you can choose one of three compilation strategies:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "#just-in-time-packages",
            children: _jsx(_components.strong, {
              children: "即时软件包"
            })
          }), "：通过允许应用打包器在使用包时对其进行编译，为你的包创建最小配置。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#just-in-time-packages",
            children: _jsx(_components.strong, {
              children: "Just-in-Time Packages"
            })
          }), ": Create minimal configuration for your package by allowing application bundlers to compile the package as it uses it."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "#compiled-packages",
            children: _jsx(_components.strong, {
              children: "已编译的软件包"
            })
          }), "：使用适量的配置，使用构建工具（例如 ", _jsx(_components.code, {
            children: "tsc"
          }), "）或打包器编译你的软件包。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#compiled-packages",
            children: _jsx(_components.strong, {
              children: "Compiled Packages"
            })
          }), ": With a moderate amount of configuration, compile your package using a build tool like ", _jsx(_components.code, {
            children: "tsc"
          }), " or a bundler."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "#publishable-packages",
            children: _jsx(_components.strong, {
              children: "可发布的软件包"
            })
          }), "：编译并准备一个包以发布到 npm 仓库。此方法需要最多的配置。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#publishable-packages",
            children: _jsx(_components.strong, {
              children: "Publishable Packages"
            })
          }), ": Compile and prepare a package to publish to the npm registry. This approach requires the most configuration."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "即时软件包-just-in-time-packages",
      children: "即时软件包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Just-in-Time Packages"
    }), "\n", _jsx(_components.p, {
      children: "即时包由使用它的应用编译。这意味着你可以直接使用你的 TypeScript（或未编译的 JavaScript）文件，所需的配置比本页上的其他策略少得多。"
    }), "\n", _jsx(_components.p, {
      children: "¥A Just-in-Time package is compiled by the application that uses it. This means you can use your TypeScript (or uncompiled JavaScript) files directly, requiring much less configuration than the other strategies on this page."
    }), "\n", _jsx(_components.p, {
      children: "此策略在以下情况下最有用："
    }), "\n", _jsx(_components.p, {
      children: "¥This strategy is most useful when:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "你的应用是使用 Turbopack、webpack 或 Vite 等现代打包工具构建的。"
        }), "\n", _jsx(_components.p, {
          children: "¥Your applications are built using a modern bundler like Turbopack, webpack, or Vite."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "你希望避免配置和设置步骤。"
        }), "\n", _jsx(_components.p, {
          children: "¥You want to avoid configuration and setup steps."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "即使软件包无法命中缓存，你对应用的构建时间也感到满意。"
        }), "\n", _jsx(_components.p, {
          children: "¥You're satisfied with your applications' build times, even when you can't hit cache for the package."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["即时包的 ", _jsx(_components.code, {
        children: "package.json"
      }), " 可能如下所示："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A ", _jsx(_components.code, {
        children: "package.json"
      }), " for a Just-in-Time package may look like this one:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@repo/ui\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"exports\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./button\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/button.tsx\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./card\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/card.tsx\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"eslint . --max-warnings 0\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsc --noEmit\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中，有几点需要注意："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥There are a few important things to notice in this ", _jsx(_components.code, {
        children: "package.json"
      }), ":"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["直接导出 TypeScript：", _jsx(_components.code, {
            children: "exports"
          }), " 字段标记包的入口点，在本例中，你直接引用的是 TypeScript 文件。这是因为应用的打包器会在构建过程中使用代码时对其进行编译。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Directly exporting TypeScript"
          }), ": The ", _jsx(_components.code, {
            children: "exports"
          }), " field marks the entrypoints for the package and, in this case, you're ", _jsx(_components.strong, {
            children: "referencing TypeScript files directly"
          }), ". This is possible because the bundler for the application will compile the code as it uses it in its build process."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["不支持 ", _jsx(_components.code, {
            children: "build"
          }), " 脚本：由于此包导出的是 TypeScript，因此无需构建步骤来转译包。这意味着你无需在此包中配置构建工具即可使其在你的工作区中工作。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.strong, {
            children: ["No ", _jsx(_components.code, {
              children: "build"
            }), " script"]
          }), ": Because this package is exporting TypeScript, it doesn't need a build step for transpiling the package. This means you don't have to configure a build tool in this package to make it work in your Workspace."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h4, {
      id: "限制和权衡-limitations-and-tradeoffs",
      children: "限制和权衡 "
    }), "\n", _jsx(_components.p, {
      children: "¥Limitations and tradeoffs"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["仅在使用者进行转译时适用：此策略仅当包将用于使用打包器或原生支持 TypeScript 的工具时才适用。消费者的打包器负责将 TypeScript 包转换为 JavaScript。如果你的构建或包的其他用法无法使用 TypeScript，则需要迁移到 ", _jsx(_components.a, {
            href: "#compiled-packages",
            children: "已编译的软件包"
          }), " 策略。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Only applicable when consumers do transpiling"
          }), ": This strategy can only be used when the package is going to be used in tooling that uses a bundler or natively understands TypeScript. The consumer's bundler is responsible for transpiling the TypeScript packages to JavaScript. If your builds or other usages of the package are not able to consume TypeScript, you will need to move to the ", _jsx(_components.a, {
            href: "#compiled-packages",
            children: "Compiled Packages"
          }), " strategy."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["不支持 TypeScript ", _jsx(_components.code, {
            children: "paths"
          }), "：正在被使用者转译的库无法使用 ", _jsx(_components.code, {
            children: "compilerOptions.paths"
          }), " 配置，因为 TypeScript 假定源代码是在编写它的包中进行转译的。如果你使用的是 TypeScript 5.4 或更高版本，我们推荐使用 ", _jsx(_components.a, {
            href: "https://devblogs.microsoft.com/typescript/announcing-typescript-5-4/#auto-import-support-for-subpath-imports",
            children: "使用 Node.js 子路径导入"
          }), "。要了解如何操作，请访问 ", _jsx(_components.a, {
            href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
            children: "我们的 TypeScript 页面"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.strong, {
            children: ["No TypeScript ", _jsx(_components.code, {
              children: "paths"
            })]
          }), ": A library that is being transpiled by its consumer cannot use the ", _jsx(_components.code, {
            children: "compilerOptions.paths"
          }), " configuration because TypeScript assumes that source code is being transpiled in the package where it is written. If you're using TypeScript 5.4 or later, we recommend ", _jsx(_components.a, {
            href: "https://devblogs.microsoft.com/typescript/announcing-typescript-5-4/#auto-import-support-for-subpath-imports",
            children: "using Node.js subpath imports"
          }), ". To learn how, visit ", _jsx(_components.a, {
            href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
            children: "our TypeScript page"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Turborepo 无法缓存即时软件包的构建：由于该包没有自己的 ", _jsx(_components.code, {
            children: "build"
          }), " 步骤，因此无法被 Turborepo 缓存。如果你希望将配置保持在最低限度，并且对应用的构建时间没有异议，那么这种权衡可能对你来说很有意义。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Turborepo cannot cache a build for a Just-in-Time Package"
          }), ": Because the package doesn't have its own ", _jsx(_components.code, {
            children: "build"
          }), " step, it can't be cached by Turborepo. This tradeoff may make sense for you if you want to keep configuration to a minimum and are okay with the build times for your applications."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "将报告内部依赖中的错误：直接导出 TypeScript 时，如果内部依赖中的代码存在 TypeScript 错误，则依赖包中的类型检查将失败。在某些情况下，你可能会发现这令人困惑或有问题。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Errors in internal dependencies will be reported"
          }), ": When directly exporting TypeScript, type-checking in a dependent package will fail if code in an internal dependency has TypeScript errors. You may find this confusing or problematic in some situations."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "已编译的软件包-compiled-packages",
      children: "已编译的软件包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Compiled Packages"
    }), "\n", _jsxs(_components.p, {
      children: ["已编译包是指使用构建工具（例如 ", _jsxs(_components.a, {
        href: "https://ts.nodejs.cn/docs/handbook/compiler-options.html#handbook-content",
        children: [_jsx(_components.code, {
          children: "tsc"
        }), "（TypeScript 编译器）"]
      }), "）自行编译的包。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A Compiled Package is a package that handles its own compilation using a build tool, like ", _jsxs(_components.a, {
        href: "https://ts.nodejs.cn/docs/handbook/compiler-options.html#handbook-content",
        children: [_jsx(_components.code, {
          children: "tsc"
        }), " (the TypeScript compiler)"]
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@repo/ui\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"exports\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./button\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/button.tsx\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"default\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/button.js\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./card\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/card.tsx\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"default\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/card.js\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsc\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["编译库会将编译后的 JavaScript 输出生成到目录（", _jsx(_components.code, {
        children: "dist"
      }), "、", _jsx(_components.code, {
        children: "build"
      }), " 等），你将使用该目录作为包的入口点。构建输出一旦添加到 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: ["任务的 ", _jsx(_components.code, {
          children: "outputs"
        }), " 键"]
      }), " 中，就会被 Turborepo 缓存，从而加快构建速度。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Compiling your library produces compiled JavaScript outputs into a directory (", _jsx(_components.code, {
        children: "dist"
      }), ", ", _jsx(_components.code, {
        children: "build"
      }), ", etc.) that you will use for the entrypoints for your package. The build outputs will be cached by Turborepo once they're added to the ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: [_jsx(_components.code, {
          children: "outputs"
        }), " key of the task"]
      }), ", allowing you to have faster build times."]
    }), "\n", _jsx(_components.h4, {
      id: "限制和权衡-limitations-and-tradeoffs-1",
      children: "限制和权衡 "
    }), "\n", _jsx(_components.p, {
      children: "¥Limitations and tradeoffs"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用 TypeScript 编译器：大多数已编译的包都应该使用 ", _jsx(_components.code, {
            children: "tsc"
          }), "。由于该软件包很可能被使用打包器的应用使用，因此应用的打包器将准备库软件包，以便在应用的最终软件包中分发，处理 polyfill、降级和其他问题。仅当你有特定用例需要它时才应使用打包器，例如将静态资源打包到包的输出中。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Using the TypeScript compiler"
          }), ": The majority of Compiled Packages should use ", _jsx(_components.code, {
            children: "tsc"
          }), ". Since the package is highly likely to be consumed by an application that is using a bundler, the application's bundler will prepare the library package for distribution in the application's final bundles, handling polyfilling, downleveling, and other concerns. A bundler should only be used if you have a specific use case that requires it, like bundling static assets into your package's outputs."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["更多配置：编译包需要更深入的知识和配置才能创建构建输出。有些 ", _jsx(_components.a, {
            href: "https://ts.nodejs.cn/docs/handbook/compiler-options.html#compiler-options",
            children: "TypeScript 编译器的许多配置"
          }), " 可能难以管理和理解，并且需要进一步配置以针对打包器（例如 ", _jsxs(_components.a, {
            href: "https://webpack.js.org/guides/tree-shaking/#mark-the-file-as-side-effect-free",
            children: [_jsx(_components.code, {
              children: "package.json"
            }), " 中的 ", _jsx(_components.code, {
              children: "sideEffects"
            }), " 键"]
          }), "）进行优化。你可以在 ", _jsx(_components.a, {
            href: "/docs/guides/tools/typescript",
            children: "我们的专用 TypeScript 指南"
          }), " 中找到我们的一些建议。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "More configuration"
          }), ": Compiled Packages require deeper knowledge and configuration to create build outputs. There are ", _jsx(_components.a, {
            href: "https://ts.nodejs.cn/docs/handbook/compiler-options.html#compiler-options",
            children: "many configurations for the TypeScript compiler"
          }), " that can be difficult to manage and understand, and further configuration to optimize for bundlers, like ", _jsxs(_components.a, {
            href: "https://webpack.js.org/guides/tree-shaking/#mark-the-file-as-side-effect-free",
            children: ["the ", _jsx(_components.code, {
              children: "sideEffects"
            }), " key in ", _jsx(_components.code, {
              children: "package.json"
            })]
          }), ". You can find some of our recommendations in ", _jsx(_components.a, {
            href: "/docs/guides/tools/typescript",
            children: "our dedicated TypeScript guide"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "可发布的包-publishable-packages",
      children: "可发布的包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Publishable packages"
    }), "\n", _jsx(_components.p, {
      children: "将包发布到 npm 仓库符合本页面打包策略中最严格的要求。由于你不了解从注册表下载包的用户将如何使用你的包，因此你可能会发现这很困难，因为要构建一个健壮的包需要进行大量配置。"
    }), "\n", _jsx(_components.p, {
      children: "¥Publishing a package to the npm registry comes with the most strict requirements of the packaging strategies on this page. Because you don't know anything about how your package will be used by consumers who download the package from the registry, you may find it difficult due to the numerous configurations required for a robust package."
    }), "\n", _jsxs(_components.p, {
      children: ["此外，将包发布到 npm 注册表的过程需要专业知识和工具。我们推荐使用 ", _jsx(_components.a, {
        href: "https://github.com/changesets/changesets",
        children: _jsx(_components.code, {
          children: "changesets"
        })
      }), " 来管理版本控制、变更日志和发布流程。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Additionally, the process of publishing a package to the npm registry requires specialized knowledge and tooling. We recommend ", _jsx(_components.a, {
        href: "https://github.com/changesets/changesets",
        children: _jsx(_components.code, {
          children: "changesets"
        })
      }), " for managing versioning, changelogs, and the publishing process."]
    }), "\n", _jsxs(_components.p, {
      children: ["详细指南：请访问 ", _jsx(_components.a, {
        href: "/docs/guides/publishing-libraries",
        children: "我们的软件包发布指南"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For a detailed guide, visit ", _jsx(_components.a, {
        href: "/docs/guides/publishing-libraries",
        children: "our Publishing packages guide"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
